(() => {
  const gallerySwipeDirection = (deltaX, deltaY, threshold = 45) => {
    if (Math.abs(deltaX) < threshold || Math.abs(deltaX) <= Math.abs(deltaY)) return 0;
    return deltaX < 0 ? 1 : -1;
  };

  const galleryNextIndex = (index, direction, length) => (index + direction + length) % length;

  const resolveTouchSwipe = (startX, startY, endX, endY, touchCount = 1) => touchCount === 1 ? gallerySwipeDirection(endX - startX, endY - startY) : 0;

  if (globalThis.__TERRAINO_TEST__) {
    globalThis.TerrainoProductGallery = Object.freeze({ gallerySwipeDirection, galleryNextIndex, resolveTouchSwipe });
  }

  const setProductMedia = (control) => {
    const scope = control.closest('[data-terraino-product]');
    if (!scope) return;
    scope.querySelectorAll('[data-terraino-product-media]').forEach((item) => {
      item.setAttribute('aria-selected', String(item === control));
      item.tabIndex = item === control ? 0 : -1;
    });
    scope.querySelectorAll('[data-terraino-product-media-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.terrainoProductMediaPanel !== control.dataset.mediaId;
    });
  };

  const restoreDialogMedia = (dialog) => {
    dialog?.querySelectorAll('iframe[data-terraino-external-video]').forEach((frame) => {
      const source = frame.dataset.terrainoVideoSource || frame.getAttribute('src');
      if (!source || frame.getAttribute('src') === source) return;
      frame.setAttribute('src', source);
    });
  };

  const stopDialogMedia = (dialog) => {
    dialog?.querySelectorAll('video').forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });
    dialog?.querySelectorAll('iframe[data-terraino-external-video]').forEach((frame) => {
      frame.dataset.terrainoVideoSource ||= frame.getAttribute('src') || '';
      frame.src = 'about:blank';
    });
  };

  const dialogOpeners = new WeakMap();

  const openDialog = (id, opener) => {
    const dialog = document.getElementById(id);
    if (dialog instanceof HTMLDialogElement && !dialog.open) {
      if (opener) dialogOpeners.set(dialog, opener);
      restoreDialogMedia(dialog);
      dialog.showModal();
    }
    return dialog;
  };

  const renderLightboxMedia = (dialog, panel) => {
    const destination = dialog?.querySelector('[data-terraino-lightbox-content]');
    if (!destination || !panel) return false;
    destination.replaceChildren(panel.cloneNode(true));
    const openButton = destination.querySelector('[data-terraino-lightbox-open]');
    if (openButton) openButton.replaceWith(...openButton.childNodes);
    dialog.dataset.terrainoLightboxMediaId = panel.dataset.terrainoProductMediaPanel;
    restoreDialogMedia(dialog);
    return true;
  };

  const imagePanelsForDialog = (dialog) => {
    const scope = dialog?.closest('[data-terraino-product]');
    return {
      scope,
      panels: [...(scope?.querySelectorAll('[data-terraino-product-media-panel]') || [])]
        .filter((panel) => panel.querySelector('[data-terraino-lightbox-open]'))
    };
  };

  const advanceLightbox = (dialog, direction) => {
    const { scope, panels } = imagePanelsForDialog(dialog);
    if (!scope || panels.length < 2) return;
    const currentId = dialog.dataset.terrainoLightboxMediaId;
    const currentIndex = Math.max(0, panels.findIndex((panel) => panel.dataset.terrainoProductMediaPanel === currentId));
    const nextPanel = panels[galleryNextIndex(currentIndex, direction, panels.length)];
    const control = scope.querySelector(`[data-terraino-product-media][data-media-id="${nextPanel.dataset.terrainoProductMediaPanel}"]`);
    if (control) setProductMedia(control);
    renderLightboxMedia(dialog, nextPanel);
  };

  const activateMediaTab = (tab) => {
    const tablist = tab.closest('[role="tablist"]');
    const container = tab.closest('.terraino-product-media-tabs');
    tablist?.querySelectorAll('[data-terraino-media-tab]').forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
    if (container) tab.focus({ preventScroll: true });
  };

  let galleryTouchStart;
  document.addEventListener('touchstart', (event) => {
    const stage = event.target.closest?.('.terraino-product__stage');
    const touch = event.touches[0];
    if (!stage || !touch || event.touches.length !== 1) {
      galleryTouchStart = undefined;
      return;
    }
    galleryTouchStart = { stage, x: touch.clientX, y: touch.clientY };
  }, { passive: true });

  document.addEventListener('touchend', (event) => {
    const touch = event.changedTouches[0];
    const start = galleryTouchStart;
    galleryTouchStart = undefined;
    if (!start || !touch || !start.stage.contains(event.target)) return;
    const direction = gallerySwipeDirection(touch.clientX - start.x, touch.clientY - start.y);
    if (!direction) return;
    const scope = start.stage.closest('[data-terraino-product]');
    const mediaControls = [...(scope?.querySelectorAll('[data-terraino-product-media]') || [])];
    const currentIndex = mediaControls.findIndex((control) => control.getAttribute('aria-selected') === 'true');
    if (currentIndex < 0 || mediaControls.length < 2) return;
    const nextIndex = galleryNextIndex(currentIndex, direction, mediaControls.length);
    setProductMedia(mediaControls[nextIndex]);
  }, { passive: true });

  let lightboxTouchStart;
  document.addEventListener('touchstart', (event) => {
    const dialog = event.target.closest?.('[data-terraino-lightbox]');
    const touch = event.touches[0];
    const interactive = event.target.closest?.('button, a, input, select, textarea');
    if (!dialog || !touch || event.touches.length !== 1 || interactive) {
      lightboxTouchStart = undefined;
      return;
    }
    lightboxTouchStart = { dialog, x: touch.clientX, y: touch.clientY };
  }, { passive: true });

  document.addEventListener('touchend', (event) => {
    const touch = event.changedTouches[0];
    const start = lightboxTouchStart;
    lightboxTouchStart = undefined;
    if (!start || !touch || !start.dialog.open || !start.dialog.contains(event.target)) return;
    if (event.target.closest?.('button, a, input, select, textarea')) return;
    const direction = resolveTouchSwipe(start.x, start.y, touch.clientX, touch.clientY, event.changedTouches.length);
    if (direction) advanceLightbox(start.dialog, direction);
  }, { passive: true });

  document.addEventListener('touchcancel', () => {
    galleryTouchStart = undefined;
    lightboxTouchStart = undefined;
  }, { passive: true });

  document.addEventListener('click', (event) => {
    const quantityAction = event.target.closest('[data-terraino-quantity-increment],[data-terraino-quantity-decrement]');
    if (quantityAction) {
      const quantity = quantityAction.closest('[data-terraino-quantity]');
      const input = quantity?.querySelector('input[name="quantity"]');
      if (!input) return;
      const amount = quantityAction.matches('[data-terraino-quantity-increment]') ? 1 : -1;
      input.value = String(Math.max(1, (Number.parseInt(input.value, 10) || 1) + amount));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const faqToggle = event.target.closest('[data-terraino-faq-toggle]');
    if (faqToggle) {
      const scope = faqToggle.closest('[data-terraino-product-faq]');
      const expanded = faqToggle.getAttribute('aria-expanded') === 'true';
      scope?.querySelectorAll('.is-extra').forEach((item) => { item.hidden = expanded; });
      faqToggle.setAttribute('aria-expanded', String(!expanded));
      faqToggle.textContent = expanded ? faqToggle.dataset.showMoreLabel : faqToggle.dataset.showLessLabel;
      return;
    }

    const media = event.target.closest('[data-terraino-product-media]');
    if (media) {
      setProductMedia(media);
      return;
    }

    const galleryStep = event.target.closest('[data-terraino-product-media-previous],[data-terraino-product-media-next]');
    if (galleryStep) {
      const scope = galleryStep.closest('[data-terraino-product]');
      const mediaControls = [...(scope?.querySelectorAll('[data-terraino-product-media]') || [])];
      const currentIndex = mediaControls.findIndex((control) => control.getAttribute('aria-selected') === 'true');
      const direction = galleryStep.matches('[data-terraino-product-media-next]') ? 1 : -1;
      if (mediaControls.length > 1) {
        const nextIndex = (currentIndex + direction + mediaControls.length) % mediaControls.length;
        setProductMedia(mediaControls[nextIndex]);
      }
      return;
    }

    const lightboxStep = event.target.closest('[data-terraino-lightbox-previous],[data-terraino-lightbox-next]');
    if (lightboxStep) {
      const dialog = lightboxStep.closest('[data-terraino-lightbox]');
      advanceLightbox(dialog, lightboxStep.matches('[data-terraino-lightbox-next]') ? 1 : -1);
      return;
    }

    const lightbox = event.target.closest('[data-terraino-lightbox-open]');
    if (lightbox) {
      const dialog = openDialog(lightbox.getAttribute('aria-controls'), lightbox);
      const panel = lightbox.closest('[data-terraino-product-media-panel]');
      renderLightboxMedia(dialog, panel);
      return;
    }

    const story = event.target.closest('[data-terraino-story]');
    if (story) {
      openDialog(story.getAttribute('aria-controls'));
      return;
    }

    const compare = event.target.closest('button[data-terraino-bundle-compare]');
    if (compare) {
      openDialog(compare.getAttribute('aria-controls'));
      return;
    }

    const closer = event.target.closest('[data-terraino-dialog-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      stopDialogMedia(dialog);
      dialog?.close();
      return;
    }

    const tab = event.target.closest('[data-terraino-media-tab]');
    if (tab) {
      activateMediaTab(tab);
    }
  });

  document.addEventListener('keydown', (event) => {
    const lightbox = event.target.closest?.('[data-terraino-lightbox]');
    if (lightbox?.open && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
      event.preventDefault();
      advanceLightbox(lightbox, event.key === 'ArrowRight' ? 1 : -1);
      return;
    }

    const tab = event.target.closest?.('[data-terraino-media-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = [...tab.closest('[role="tablist"]')?.querySelectorAll('[data-terraino-media-tab]') || []];
    if (!tabs.length) return;
    const index = tabs.indexOf(tab);
    const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    activateMediaTab(tabs[nextIndex]);
  });

  document.addEventListener('close', (event) => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    const dialog = event.target;
    stopDialogMedia(dialog);
    const opener = dialogOpeners.get(dialog);
    dialogOpeners.delete(dialog);
    const currentId = dialog.dataset.terrainoLightboxMediaId;
    const currentOpener = currentId
      ? dialog.closest('[data-terraino-product]')?.querySelector(`[data-terraino-product-media-panel="${currentId}"] [data-terraino-lightbox-open]`)
      : null;
    const focusTarget = currentOpener?.isConnected ? currentOpener : opener;
    if (focusTarget?.isConnected) focusTarget.focus({ preventScroll: true });
  }, true);
})();
